import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import ErrorContainer from './ErrorContainer';
import EnvDetails from './tabs/DetailsTab';
import EnvInsights from './tabs/InsightsTab';

const EnvConfiguration = React.lazy(() => import('./tabs/ConfigurationTab'));
const EnvConfigurationRoute = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <EnvConfiguration />
    </Suspense>
  );
};

const EnvRoutes = () => {
  return (
    <ErrorContainer>
      <Routes>
        <Route path="details" Component={EnvDetails} />
        <Route path="deploy" Component={EnvConfigurationRoute} />
        <Route path="insights" Component={EnvInsights} />
      </Routes>
    </ErrorContainer>
  );
};

export default EnvRoutes;
